import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useDispatch, useSelector } from 'react-redux';
import { setGroupView } from '@/features/userPrefs/userPrefsSlice';
import { useGetUserDetailsQuery } from '@/features/user/userApi';

export const TeamViewToggle = () => {
	const dispatch = useDispatch();

	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery(
		{ email },
		{
			skip: !email,
		},
	);

	const { groupView } = useSelector((state) => state.userPrefs);

	const handleChange = (event, newView) => {
		if (newView !== null) {
			dispatch(setGroupView(newView));
		}
	};

	if (!userDetails?.canViewGroup) {
		return <></>;
	}

	return (
		<ToggleButtonGroup
			color='primary'
			value={groupView}
			size='small'
			exclusive
			onChange={handleChange}
			sx={{
				boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
				'& .MuiToggleButtonGroup-grouped': {
					border: 'none',
					margin: '4px',
					padding: '2px 8px',
					'&:not(:first-of-type)': {
						borderRadius: '5px',
					},
					'&:first-of-type': {
						borderRadius: '5px',
					},
					// Styles for unselected buttons
					color: 'rgba(189, 189, 189, 1)',
					backgroundColor: 'transparent',
					'&.Mui-selected': {
						color: 'primary.main',
						backgroundColor: 'rgba(80, 90, 252, 0.33)',
					},
					'&:hover': {
						backgroundColor: 'rgba(80, 90, 252, 0.1)',
					},
				},
			}}
		>
			<ToggleButton value={false}>Me</ToggleButton>
			<ToggleButton value={true}>My Team</ToggleButton>
		</ToggleButtonGroup>
	);
};
